const GetWidgetTitle = (widgetId, queryId, view) => view.state.get(queryId).titles.getIn(["widget", widgetId]);
export default GetWidgetTitle;
